import { render } from "./PhotoSwipe.vue?vue&type=template&id=14110ba2"
import script from "./PhotoSwipe.vue?vue&type=script&lang=js"
export * from "./PhotoSwipe.vue?vue&type=script&lang=js"

import exportComponent from "/Volumes/www/Projects/Semperit/www.semperitgroup.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__